// Global Risk Index — the real Doomsday Clock reading, not a decorative stat.
// Update this (and the needle rotation in HudCompass.tsx) if/when the Bulletin
// moves the clock — see the build reminder in the vault about a scheduled
// check for this once the WordPress backend can drive it automatically.
export default function RiskIndex() {
  return (
    <div className="risk" role="group" aria-label="Global risk index">
      <div className="risk-top">
        <span className="risk-lab">Global Risk Index</span>
        <span className="risk-val tnum">
          85<span className="u">s</span>
          <span className="tomid">to midnight</span>
        </span>
      </div>
      <div className="risk-bar" aria-hidden="true">
        <i></i>
        <span className="mid"></span>
      </div>
      <p className="risk-explain">
        A symbolic measure of how close humanity is to global catastrophe (nuclear conflict, climate change, disruptive tech),
        published annually. Not a literal countdown.
      </p>
      <div className="risk-src">
        Doomsday Clock &middot; set Jan 2026 &middot; closest ever &middot;{' '}
        <a href="https://thebulletin.org/doomsday-clock/2026-statement/" target="_blank" rel="noopener">
          Bulletin of the Atomic Scientists &#8599;
        </a>
      </div>
    </div>
  )
}
